import { render, staticRenderFns } from "./CatchPermissions.vue?vue&type=template&id=3472d28a&"
import script from "./CatchPermissions.vue?vue&type=script&lang=js&"
export * from "./CatchPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports